// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-5151d280] {\n  margin-top: 12px;\n}\n.icon-download_icon[data-v-5151d280] {\n  margin-right: 10px;\n}\n.download-button span[data-v-5151d280] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
